<mat-dialog-content>
  <lemon-dialog-header> Selvityspyyntö </lemon-dialog-header>

  <div class="tosite-tiedot">
    <div class="gray-text" style="margin-bottom: 20px">
      {{ pvm | lokaalipvm | async }}
      @if (summa || summa === 0) {
        <span style="margin-left: 10px">{{ summa | number: '1.2-2' }}€</span>
      }
      @if (maksunsaaja) {
        <span style="margin-left: 10px">{{ maksunsaaja }}</span>
      }
    </div>
    <form novalidate style="margin: 0">
      <div style="margin-bottom: 20px">
        <label id="selvityspyynnon-tyyppi-label" style="display: block; margin-bottom: 5px">Tyyppi</label>
        <mat-radio-group aria-labelledby="selvityspyynnon-tyyppi-label" [formField]="lomake.tyyppi">
          <mat-radio-button [value]="'kuititon'">Tosite puuttuu — asiakas lisää tositteen</mat-radio-button><br />
          <mat-radio-button [value]="'lisatietopyynto'">Lisätietopyyntö — asiakas vastaa viestillä</mat-radio-button>
        </mat-radio-group>
      </div>
      <mat-form-field>
        <mat-label>Viesti asiakkaalle</mat-label>
        <textarea matInput [formField]="lomake.viesti" cdkTextareaAutosize data-lpignore="true"></textarea>
        <mat-error>Selvityspyyntö tarvitsee viestin asiakkaalle</mat-error>
      </mat-form-field>
    </form>

    @if (tositteet.length) {
      <div class="tositteet-valinta">
        <div class="tositteet-otsikko">Selvityspyynnön tositteet</div>
        @for (tosite of tositteet; track tosite.avain) {
          <div>
            <mat-checkbox [checked]="onkoTositeValittu(tosite.avain)" (change)="vaihdaTositeValinta(tosite.avain, $event.checked)">
              {{ tosite.otsikko }}
              @if (tosite.pvm) {
                <span class="gray-text" style="margin-left: 5px">{{ tosite.pvm | lokaalipvm | async }}</span>
              }
              @if (tosite.summa !== undefined) {
                <span class="gray-text" style="margin-left: 5px">{{ tosite.summa | number: '1.2-2' }}€</span>
              }
              @if (tosite.selite) {
                <span class="gray-text">, {{ tosite.selite }}</span>
              }
            </mat-checkbox>
          </div>
        }
      </div>
    }

    @if (laskut.length) {
      <div class="tositteet-valinta">
        <div class="tositteet-otsikko">Liitettävät laskut</div>
        @for (lasku of laskut; track lasku.avain) {
          <div>
            <mat-checkbox [checked]="onkoLaskuValittu(lasku.avain)" (change)="vaihdaLaskuValinta(lasku.avain, $event.checked)">
              {{ lasku.otsikko }}
              @if (lasku.laskunumero) {
                <span class="gray-text" style="margin-left: 5px">nro {{ lasku.laskunumero }}</span>
              }
              @if (lasku.pvm) {
                <span class="gray-text" style="margin-left: 5px">{{ lasku.pvm | lokaalipvm | async }}</span>
              }
              @if (lasku.summa !== undefined) {
                <span class="gray-text" style="margin-left: 5px">{{ lasku.summa | number: '1.2-2' }}€</span>
              }
            </mat-checkbox>
          </div>
        }
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions style="padding-left: 0; padding-right: 0; justify-content: space-around; justify-content: space-evenly">
  <app-secondary-button [focusRegionStart]="true" mat-dialog-close actionId="Peruuta (selvityspyyntö dialog)">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Muokattu selvityspyyntöä" [actionContext]="[lomake().value()]">Tallenna</app-primary-button>
</mat-dialog-actions>
